import { render, staticRenderFns } from "./restless-river.vue?vue&type=template&id=be801896&scoped=true"
import script from "./restless-river.vue?vue&type=script&lang=js"
export * from "./restless-river.vue?vue&type=script&lang=js"
import style0 from "./restless-river.vue?vue&type=style&index=0&id=be801896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be801896",
  null
  
)

export default component.exports